import { z } from 'zod/v3';
import { transformNullish } from '../../../../common/utils/schema';

export const AlgorithmFilterClauseFormDataSchema = z.object({
  algorithmId: z.number(),
  filterClause: transformNullish<string>(z.string(), ''),
});
